import { createAction, props } from '@ngrx/store';
import { ContentId } from '../../types/content-block';
import { RADIO_OPTION_TYPE } from '../../types/radio-option';

export const updateCheckpoint = createAction(
    '[Forms] Update checkpoint',
    props<{
        xmlId: string;
        selected: RADIO_OPTION_TYPE | undefined;
    }>(),
);
export const updateCheckpoints = createAction(
    '[Forms] Update multiple checkpoints',
    props<{
        xmlIds: string[];
        selected: RADIO_OPTION_TYPE | undefined;
    }>(),
);
export const autofillCheckpoints = createAction(
    '[Forms] Autofill checkpoints in content block',
    props<{
        id: ContentId;
        selected: RADIO_OPTION_TYPE;
    }>(),
);
